// Module
var code = "<template bindable=\"displayTimeZone\" show.bind=\"displayTimeZone\"> <i ess-icon=\"ui:icons.info\"> <ess-tooltip> <div class=\"tooltip-content-section\"> <span>${displayTimeZone.$display}</span> </div> </ess-tooltip> </i> <span>${displayTimeZone.description}</span> </template> ";
// Exports
module.exports = code;